import { SUPPORTED_PROVIDERS } from "../constants";

export function getEdgeCenter({ sourceX, sourceY, targetX, targetY }: { sourceX: number; sourceY: number; targetX: number; targetY: number }): [number, number, number, number] {
  const xOffset = Math.abs(targetX - sourceX) / 2;
  const centerX = targetX < sourceX ? targetX + xOffset : targetX - xOffset;

  const yOffset = Math.abs(targetY - sourceY) / 2;
  const centerY = targetY < sourceY ? targetY + yOffset : targetY - yOffset;

  return [centerX, centerY, xOffset, yOffset];
}

export const isFeatureEnabled = (featurePath, features) => {
  if (!featurePath) return false;
  const keys = featurePath.split(".");
  if (keys[0] === "mfa") {
    keys.shift();
    // All keys must be true in mfafeatures.Data
    return keys.every((key) => features?.mfa?.Data?.[key] === true);
  } else {
    // ...existing logic for non-mfa features...
    let current = features;
    for (const key of keys) {
      if (!current || current[key] !== true) return false;
      current = current[key];
    }
    return true;
  }
};

export const downloadFile = ({ data, fileName, fileType }: any) => {
  // Create a blob with the data we want to download as a file
  const blob = new Blob([data], { type: fileType });
  // Create an anchor element and dispatch a click event on it
  // to trigger a download
  const a = document.createElement("a");
  a.download = fileName;
  a.href = window.URL.createObjectURL(blob);
  const clickEvt = new MouseEvent("click", {
    view: window,
    bubbles: true,
    cancelable: true
  });
  a.dispatchEvent(clickEvt);
  a.remove();
};

export const updateDynamicProperties = (type: any, initialId: string, recursiveId: any, nodes: any, tree: any, setNodes: any, setSelectedNode: any, visitedNodesIdArray: any[] = []) => {
  if (
    nodes.find((node: any) => {
      return node.id === recursiveId && node.type === "webpage";
    })
  ) {
    setNodes((nds: any) =>
      nds.map((node: any) => {
        if (node.id === initialId) {
          node.data.properties.find((property: any) => {
            return property.id === "1" && Array.isArray(property.options)
              ? property.options.splice(
                  0,
                  property.options.length,
                  ...nodes
                    .find((node: any) => {
                      return node.id === recursiveId;
                    })
                    .nodes.filter((node: any) => {
                      return type === "auth" ? SUPPORTED_PROVIDERS.includes(node.type) : type === "sendotp" ? node.type === "email" || node.type === "phone" : null;
                    })
                    .map((node: any) => {
                      return {
                        text: node.data.label,
                        value: node.type
                      };
                    })
                )
              : null;
          });
        }

        return node;
      })
    );
  }
  if (!recursiveId) {
    setNodes((nds: any) =>
      nds.map((node: any) => {
        if (node.id === initialId) {
          node.data.properties.find((property: any) => {
            if (property.type === "input" && property.id === "1") {
              property.options.length = 0;
              property.value = "";
            }
          });
        }

        return node;
      })
    );

    return;
  } else if (tree.entryNodeId === recursiveId) {
    visitedNodesIdArray.length = 0;

    return;
  }

  const nextNodeIdArray = Object.keys(tree.nodes).filter((node: any) => {
    return tree.nodes[node].connections.find((conn: any) => {
      return conn.output === recursiveId || conn.true === recursiveId || conn.false === recursiveId;
    });
  });

  visitedNodesIdArray.push(recursiveId);

  const updatedNextNodeArray = nextNodeIdArray.filter((element) => !visitedNodesIdArray.includes(element));
  updatedNextNodeArray.length
    ? updatedNextNodeArray.map((nextNodeId: any) => {
        // console.log(visitedNodesIdArray);
        return updateDynamicProperties(type, initialId, nextNodeId, nodes, tree, setNodes, setSelectedNode, visitedNodesIdArray);
      })
    : updateDynamicProperties(type, initialId, null, nodes, tree, setNodes, setSelectedNode, visitedNodesIdArray);
  return;
};

export const countryCodeMap = {
  optionsofsetcountrycode: [
    {
      text: "(+93) Afghanistan",
      value: "AF"
    },
    {
      text: "(+355) Albania",
      value: "AL"
    },
    {
      text: "(+213) Algeria",
      value: "DZ"
    },
    {
      text: "(+1684) American Samoa",
      value: "AS"
    },
    {
      text: "(+376) Andorra",
      value: "AD"
    },
    {
      text: "(+244) Angola",
      value: "AO"
    },
    {
      text: "(+1264) Anguilla",
      value: "AI"
    },
    {
      text: "(+672) Antarctica",
      value: "AQ"
    },
    {
      text: "(+1268) Antigua and Barbuda",
      value: "AG"
    },
    {
      text: "(+54) Argentina",
      value: "AR"
    },
    {
      text: "(+374) Armenia",
      value: "AM"
    },
    {
      text: "(+297) Aruba",
      value: "AW"
    },
    {
      text: "(+61) Australia",
      value: "AU"
    },
    {
      text: "(+43) Austria",
      value: "AT"
    },
    {
      text: "(+994) Azerbaijan",
      value: "AZ"
    },
    {
      text: "(+973) Bahrain",
      value: "BH"
    },
    {
      text: "(+1242) The Bahamas",
      value: "BS"
    },
    {
      text: "(+880) Bangladesh",
      value: "BD"
    },
    {
      text: "(+1 246) Barbados",
      value: "BB"
    },
    {
      text: "(+375) Belarus",
      value: "BY"
    },
    {
      text: "(+32) Belgium",
      value: "BE"
    },
    {
      text: "(+501) Belize",
      value: "BZ"
    },
    {
      text: "(+229) Benin",
      value: "BJ"
    },
    {
      text: "(+1441) Bermuda",
      value: "BM"
    },
    {
      text: "(+975) Bhutan",
      value: "BT"
    },
    {
      text: "(+591) Bolivia",
      value: "BO"
    },
    {
      text: "(+599) Bonaire",
      value: "BQ"
    },
    {
      text: "(+387) Bosnia and Herzegovina",
      value: "BA"
    },
    {
      text: "(+267) Botswana",
      value: "BW"
    },
    {
      text: "(+47) Bouvet",
      value: "BV"
    },
    {
      text: "(+55) Brazil",
      value: "BR"
    },
    {
      text: "(+246) British Indian Ocean Territory",
      value: "IO"
    },
    {
      text: "(+1284) British Virgin Islands",
      value: "VG"
    },
    {
      text: "(+673) Brunei",
      value: "BN"
    },
    {
      text: "(+359) Bulgaria",
      value: "BG"
    },
    {
      text: "(+226) Burkina Faso",
      value: "BF"
    },
    {
      text: "(+95) Myanmar",
      value: "MM"
    },
    {
      text: "(+257) Burundi",
      value: "BI"
    },
    {
      text: "(+855) Cambodia",
      value: "KH"
    },
    {
      text: "(+237) Cameroon",
      value: "CM"
    },
    {
      text: "(+1) Canada",
      value: "CA"
    },
    {
      text: "(+238) Cape Verde",
      value: "CV"
    },
    {
      text: "(+1345) Cayman Islands",
      value: "KY"
    },
    {
      text: "(+236) Central African Republic",
      value: "CF"
    },
    {
      text: "(+235) Chad",
      value: "TD"
    },
    {
      text: "(+56) Chile",
      value: "CL"
    },
    {
      text: "(+86) China",
      value: "CN"
    },
    {
      text: "(+61) Christmas Island",
      value: "CX"
    },
    {
      text: "(+672) Cocos-Keeling Islands",
      value: "CC"
    },
    {
      text: "(+57) Colombia",
      value: "CO"
    },
    {
      text: "(+269) Comoros",
      value: "KM"
    },
    {
      text: "(+242) Congo",
      value: "CG"
    },
    {
      text: "(+243) Congo, Dem. Rep. of (Zaire)",
      value: "CD"
    },
    {
      text: "(+682) Cook Islands",
      value: "CK"
    },
    {
      text: "(+506) Costa Rica",
      value: "CR"
    },
    {
      text: "(+225) Cote d'Ivoire",
      value: "CI"
    },
    {
      text: "(+385) Croatia",
      value: "HR"
    },
    {
      text: "(+599) Curacao",
      value: "CW"
    },
    {
      text: "(+53) Cuba",
      value: "CU"
    },
    {
      text: "(+357) Cyprus",
      value: "CY"
    },
    {
      text: "(+420) Czech Republic",
      value: "CZ"
    },
    {
      text: "(+45) Denmark",
      value: "DK"
    },
    {
      text: "(+253) Djibouti",
      value: "DJ"
    },
    {
      text: "(+1767) Dominica",
      value: "DM"
    },
    {
      text: "(+1809) Dominican Republic",
      value: "DO"
    },
    {
      text: "(+670) East Timor",
      value: "TL"
    },
    {
      text: "(+593) Ecuador",
      value: "EC"
    },
    {
      text: "(+20) Egypt",
      value: "EG"
    },
    {
      text: "(+503) El Salvador",
      value: "SV"
    },
    {
      text: "(+240) Equatorial Guinea",
      value: "GQ"
    },
    {
      text: "(+291) Eritrea",
      value: "ER"
    },
    {
      text: "(+372) Estonia",
      value: "EE"
    },
    {
      text: "(+251) Ethiopia",
      value: "ET"
    },
    {
      text: "(+500) Falkland Islands",
      value: "FK"
    },
    {
      text: "(+679) Fiji",
      value: "FO"
    },
    {
      text: "(+358) Finland",
      value: "FI"
    },
    {
      text: "(+33) France",
      value: "FR"
    },
    {
      text: "(+594) French Guiana",
      value: "GF"
    },
    {
      text: "(+689) French Polynesia",
      value: "PF"
    },
    {
      text: "(+262) French Southern and Antarctic Lands",
      value: "TF"
    },
    {
      text: "(+241) Gabon",
      value: "GA"
    },
    {
      text: "(+220) The Gambia",
      value: "GM"
    },
    {
      text: "(+995) Georgia",
      value: "GE"
    },
    {
      text: "(+49) Germany",
      value: "DE"
    },
    {
      text: "(+233) Ghana",
      value: "GH"
    },
    {
      text: "(+30) Greece",
      value: "GR"
    },
    {
      text: "(+299) Greenland",
      value: "GL"
    },
    {
      text: "(+1473) Grenada",
      value: "GD"
    },
    {
      text: "(+590) Guadeloupe",
      value: "GP"
    },
    {
      text: "(+1671) Guam",
      value: "GU"
    },
    {
      text: "(+502) Guatemala",
      value: "GT"
    },
    {
      text: "(+44) Guernsey",
      value: "GG"
    },
    {
      text: "(+224) Guinea",
      value: "GN"
    },
    {
      text: "(+245) Guinea-Bissau",
      value: "GW"
    },
    {
      text: "(+592) Guyana",
      value: "GY"
    },
    {
      text: "(+509) Haiti",
      value: "HT"
    },
    {
      text: "(+0) Heard Island and McDonald Islands",
      value: "HM"
    },
    {
      text: "(+39) Holy See (Vatican City)",
      value: "VA"
    },
    {
      text: "(+504) Honduras",
      value: "HN"
    },
    {
      text: "(+852) Hong Kong SAR China",
      value: "HK"
    },
    {
      text: "(+36) Hungary",
      value: "HU"
    },
    {
      text: "(+354) Iceland",
      value: "IS"
    },
    {
      text: "(+91) India",
      value: "IN"
    },
    {
      text: "(+62) Indonesia",
      value: "ID"
    },
    {
      text: "(+98) Iran",
      value: "IR"
    },
    {
      text: "(+964) Iraq",
      value: "IQ"
    },
    {
      text: "(+353) Ireland",
      value: "IE"
    },
    {
      text: "(+44) Isle of Man",
      value: "IM"
    },
    {
      text: "(+972) Israel",
      value: "IL"
    },
    {
      text: "(+39) Italy",
      value: "IT"
    },
    {
      text: "(+1876) Jamaica",
      value: "JM"
    },
    {
      text: "(+81) Japan",
      value: "JP"
    },
    {
      text: "(+962) Jordan",
      value: "JO"
    },
    {
      text: "(+7) Kazakhstan",
      value: "KZ"
    },
    {
      text: "(+254) Kenya",
      value: "KE"
    },
    {
      text: "(+686) Kiribati",
      value: "KI"
    },
    {
      text: "(+965) Kuwait",
      value: "KW"
    },
    {
      text: "(+996) Kyrgyzstan",
      value: "KG"
    },
    {
      text: "(+856) Laos",
      value: "LA"
    },
    {
      text: "(+371) Latvia",
      value: "LV"
    },
    {
      text: "(+961) Lebanon",
      value: "LB"
    },
    {
      text: "(+266) Lesotho",
      value: "LS"
    },
    {
      text: "(+231) Liberia",
      value: "LR"
    },
    {
      text: "(+218) Libya",
      value: "LY"
    },
    {
      text: "(+423) Liechtenstein",
      value: "LI"
    },
    {
      text: "(+370) Lithuania",
      value: "LT"
    },
    {
      text: "(+352) Luxembourg",
      value: "LU"
    },
    {
      text: "(+853) Macau SAR China",
      value: "MO"
    },
    {
      text: "(+389) Macedonia",
      value: "MK"
    },
    {
      text: "(+261) Madagascar",
      value: "MG"
    },
    {
      text: "(+265) Malawi",
      value: "MW"
    },
    {
      text: "(+60) Malaysia",
      value: "MY"
    },
    {
      text: "(+960) Maldives",
      value: "MV"
    },
    {
      text: "(+223) Mali",
      value: "ML"
    },
    {
      text: "(+356) Malta",
      value: "MT"
    },
    {
      text: "(+692) Marshall Islands",
      value: "MH"
    },
    {
      text: "(+596) Martinique",
      value: "MQ"
    },
    {
      text: "(+222) Mauritania",
      value: "MR"
    },
    {
      text: "(+230) Mauritius",
      value: "MU"
    },
    {
      text: "(+262) Mayotte",
      value: "YT"
    },
    {
      text: "(+52) Mexico",
      value: "MX"
    },
    {
      text: "(+691) Micronesia, Federated States Of",
      value: "FM"
    },
    {
      text: "(+1808) Midway Island",
      value: "MI"
    },
    {
      text: "(+373) Moldova",
      value: "MD"
    },
    {
      text: "(+377) Monaco",
      value: "MC"
    },
    {
      text: "(+976) Mongolia",
      value: "MN"
    },
    {
      text: "(+382) Montenegro",
      value: "ME"
    },
    {
      text: "(+1664) Montserrat",
      value: "MS"
    },
    {
      text: "(+212) Morocco",
      value: "MA"
    },
    {
      text: "(+258) Mozambique",
      value: "MZ"
    },
    {
      text: "(+264) Namibia",
      value: "NA"
    },
    {
      text: "(+674) Nauru",
      value: "NR"
    },
    {
      text: "(+977) Nepal",
      value: "NP"
    },
    {
      text: "(+31) Netherlands",
      value: "NL"
    },
    {
      text: "(+599) Netherlands Antilles",
      value: "AN"
    },
    {
      text: "(+687) New Caledonia",
      value: "NC"
    },
    {
      text: "(+64) New Zealand",
      value: "NZ"
    },
    {
      text: "(+505) Nicaragua",
      value: "NI"
    },
    {
      text: "(+227) Niger",
      value: "NE"
    },
    {
      text: "(+234) Nigeria",
      value: "NG"
    },
    {
      text: "(+683) Niue",
      value: "NU"
    },
    {
      text: "(+672) Norfolk Island",
      value: "NF"
    },
    {
      text: "(+850) North Korea",
      value: "KP"
    },
    {
      text: "(+1670) Northern Mariana Islands",
      value: "MP"
    },
    {
      text: "(+47) Norway",
      value: "NO"
    },
    {
      text: "(+968) Oman",
      value: "OM"
    },
    {
      text: "(+92) Pakistan",
      value: "PK"
    },
    {
      text: "(+680) Palau",
      value: "PW"
    },
    {
      text: "(+507) Panama",
      value: "PA"
    },
    {
      text: "(+675) Papua New Guinea",
      value: "PG"
    },
    {
      text: "(+595) Paraguay",
      value: "PY"
    },
    {
      text: "(+51) Peru",
      value: "PE"
    },
    {
      text: "(+63) Philippines",
      value: "PH"
    },
    {
      text: "(+870) Pitcairn Islands",
      value: "PN"
    },
    {
      text: "(+48) Poland",
      value: "PL"
    },
    {
      text: "(+351) Portugal",
      value: "PT"
    },
    {
      text: "(+1787) Puerto Rico",
      value: "PR"
    },
    {
      text: "(+974) Qatar",
      value: "QA"
    },
    {
      text: "(+262) Reunion",
      value: "RE"
    },
    {
      text: "(+40) Romania",
      value: "RO"
    },
    {
      text: "(+7) Russia",
      value: "RU"
    },
    {
      text: "(+250) Rwanda",
      value: "RW"
    },
    {
      text: "(+590) Saint Barthelemy",
      value: "BL"
    },
    {
      text: "(+290) Saint Helena",
      value: "SH"
    },
    {
      text: "(+1869) Saint Kitts and Nevis",
      value: "KN"
    },
    {
      text: "(+1758) Saint Lucia",
      value: "LC"
    },
    {
      text: "(+1) Saint Martin",
      value: "MF"
    },
    {
      text: "(+508) Saint Pierre and Miquelon",
      value: "PM"
    },
    {
      text: "(+239) Saint tome and principle",
      value: "ST"
    },
    {
      text: "(+1784) Saint Vincent and the Grenadines",
      value: "VC"
    },
    {
      text: "(+684) Samoa",
      value: "WS"
    },
    {
      text: "(+378) San Marino",
      value: "SM"
    },
    {
      text: "(+966) Saudi Arabia",
      value: "SA"
    },
    {
      text: "(+221) Senegal",
      value: "SN"
    },
    {
      text: "(+381) Serbia",
      value: "RS"
    },
    {
      text: "(+248) Seychelles",
      value: "SC"
    },
    {
      text: "(+232) Sierra Leone",
      value: "SL"
    },
    {
      text: "(+65) Singapore",
      value: "SG"
    },
    {
      text: "(+721) Sint Maarten",
      value: "SX"
    },
    {
      text: "(+421) Slovakia",
      value: "SK"
    },
    {
      text: "(+386) Slovenia",
      value: "SI"
    },
    {
      text: "(+677) Solomon Islands",
      value: "SB"
    },
    {
      text: "(+27) South Africa",
      value: "ZA"
    },
    {
      text: "(+500) South Georgia and the South Sandwich Islands",
      value: "GS"
    },
    {
      text: "(+82) South Korea",
      value: "KR"
    },
    {
      text: "(+211) South Sudan",
      value: "SS"
    },
    {
      text: "(+34) Spain",
      value: "ES"
    },
    {
      text: "(+94) Sri Lanka",
      value: "LK"
    },
    {
      text: "(+249) Sudan",
      value: "SD"
    },
    {
      text: "(+597) Suriname",
      value: "SR"
    },
    {
      text: "(+47) Svalbard",
      value: "SJ"
    },
    {
      text: "(+268) Swaziland",
      value: "SZ"
    },
    {
      text: "(+46) Sweden",
      value: "SE"
    },
    {
      text: "(+41) Switzerland",
      value: "CH"
    },
    {
      text: "(+963) Syria",
      value: "SY"
    },
    {
      text: "(+886) Taiwan",
      value: "TW"
    },
    {
      text: "(+992) Tajikistan",
      value: "TJ"
    },
    {
      text: "(+255) Tanzania",
      value: "TZ"
    },
    {
      text: "(+66) Thailand",
      value: "TH"
    },
    {
      text: "(+228) Togo",
      value: "TG"
    },
    {
      text: "(+690) Tokelau",
      value: "TK"
    },
    {
      text: "(+676) Tonga",
      value: "TO"
    },
    {
      text: "(+1868) Trinidad and Tobago",
      value: "TT"
    },
    {
      text: "(+216) Tunisia",
      value: "TN"
    },
    {
      text: "(+90) Turkey",
      value: "TR"
    },
    {
      text: "(+7370) Turkmenistan",
      value: "TM"
    },
    {
      text: "(+1649) Turks and Caicos Islands",
      value: "TC"
    },
    {
      text: "(+688) Tuvalu",
      value: "TV"
    },
    {
      text: "(+256) Uganda",
      value: "UG"
    },
    {
      text: "(+380) Ukraine",
      value: "UA"
    },
    {
      text: "(+971) United Arab Emirates",
      value: "AE"
    },
    {
      text: "(+44) United Kingdom",
      value: "UK"
    },
    {
      text: "(+1) United States Minor Outlying Islands",
      value: "UM"
    },
    {
      text: "(+1) United States",
      value: "US"
    },
    {
      text: "(+598) Uruguay",
      value: "UY"
    },
    {
      text: "(+998) Uzbekistan",
      value: "UZ"
    },
    {
      text: "(+678) Vanuatu",
      value: "VU"
    },
    {
      text: "(+58) Venezuela",
      value: "VE"
    },
    {
      text: "(+84) Vietnam",
      value: "VN"
    },
    {
      text: "(+1340) Virgin Islands",
      value: "VI"
    },
    {
      text: "(+681) Wallis and Futuna",
      value: "WF"
    },
    {
      text: "(+212) Western Sahara",
      value: "EH"
    },
    {
      text: "(+967) Yemen",
      value: "YE"
    },
    {
      text: "(+260) Zambia",
      value: "ZM"
    },
    {
      text: "(+263) Zimbabwe",
      value: "ZW"
    }
  ],

  optionsofallowcountrycode: [
    {
      text: "(+93) Afghanistan",
      value: "AF",
      checked: false
    },
    {
      text: "(+355) Albania",
      value: "AL",
      checked: false
    },
    {
      text: "(+213) Algeria",
      value: "DZ",
      checked: false
    },
    {
      text: "(+1684) American Samoa",
      value: "AS",
      checked: false
    },
    {
      text: "(+376) Andorra",
      value: "AD",
      checked: false
    },
    {
      text: "(+244) Angola",
      value: "AO",
      checked: false
    },
    {
      text: "(+1264) Anguilla",
      value: "AI",
      checked: false
    },
    {
      text: "(+672) Antarctica",
      value: "AQ",
      checked: false
    },
    {
      text: "(+1268) Antigua and Barbuda",
      value: "AG",
      checked: false
    },
    {
      text: "(+54) Argentina",
      value: "AR",
      checked: false
    },
    {
      text: "(+374) Armenia",
      value: "AM",
      checked: false
    },
    {
      text: "(+297) Aruba",
      value: "AW",
      checked: false
    },
    {
      text: "(+61) Australia",
      value: "AU",
      checked: false
    },
    {
      text: "(+43) Austria",
      value: "AT",
      checked: false
    },
    {
      text: "(+994) Azerbaijan",
      value: "AZ",
      checked: false
    },
    {
      text: "(+973) Bahrain",
      value: "BH",
      checked: false
    },
    {
      text: "(+1242) The Bahamas",
      value: "BS",
      checked: false
    },
    {
      text: "(+880) Bangladesh",
      value: "BD",
      checked: false
    },
    {
      text: "(+1 246) Barbados",
      value: "BB",
      checked: false
    },
    {
      text: "(+375) Belarus",
      value: "BY",
      checked: false
    },
    {
      text: "(+32) Belgium",
      value: "BE",
      checked: false
    },
    {
      text: "(+501) Belize",
      value: "BZ",
      checked: false
    },
    {
      text: "(+229) Benin",
      value: "BJ",
      checked: false
    },
    {
      text: "(+1441) Bermuda",
      value: "BM",
      checked: false
    },
    {
      text: "(+975) Bhutan",
      value: "BT",
      checked: false
    },
    {
      text: "(+591) Bolivia",
      value: "BO",
      checked: false
    },
    {
      text: "(+599) Bonaire",
      value: "BQ",
      checked: false
    },
    {
      text: "(+387) Bosnia and Herzegovina",
      value: "BA",
      checked: false
    },
    {
      text: "(+267) Botswana",
      value: "BW",
      checked: false
    },
    {
      text: "(+47) Bouvet",
      value: "BV",
      checked: false
    },
    {
      text: "(+55) Brazil",
      value: "BR",
      checked: false
    },
    {
      text: "(+246) British Indian Ocean Territory",
      value: "IO",
      checked: false
    },
    {
      text: "(+1284) British Virgin Islands",
      value: "VG",
      checked: false
    },
    {
      text: "(+673) Brunei",
      value: "BN",
      checked: false
    },
    {
      text: "(+359) Bulgaria",
      value: "BG",
      checked: false
    },
    {
      text: "(+226) Burkina Faso",
      value: "BF",
      checked: false
    },
    {
      text: "(+95) Myanmar",
      value: "MM",
      checked: false
    },
    {
      text: "(+257) Burundi",
      value: "BI",
      checked: false
    },
    {
      text: "(+855) Cambodia",
      value: "KH",
      checked: false
    },
    {
      text: "(+237) Cameroon",
      value: "CM",
      checked: false
    },
    {
      text: "(+1) Canada",
      value: "CA",
      checked: false
    },
    {
      text: "(+238) Cape Verde",
      value: "CV",
      checked: false
    },
    {
      text: "(+1345) Cayman Islands",
      value: "KY",
      checked: false
    },
    {
      text: "(+236) Central African Republic",
      value: "CF",
      checked: false
    },
    {
      text: "(+235) Chad",
      value: "TD",
      checked: false
    },
    {
      text: "(+56) Chile",
      value: "CL",
      checked: false
    },
    {
      text: "(+86) China",
      value: "CN",
      checked: false
    },
    {
      text: "(+61) Christmas Island",
      value: "CX",
      checked: false
    },
    {
      text: "(+672) Cocos-Keeling Islands",
      value: "CC",
      checked: false
    },
    {
      text: "(+57) Colombia",
      value: "CO",
      checked: false
    },
    {
      text: "(+269) Comoros",
      value: "KM",
      checked: false
    },
    {
      text: "(+242) Congo",
      value: "CG",
      checked: false
    },
    {
      text: "(+243) Congo, Dem. Rep. of (Zaire)",
      value: "CD",
      checked: false
    },
    {
      text: "(+682) Cook Islands",
      value: "CK",
      checked: false
    },
    {
      text: "(+506) Costa Rica",
      value: "CR",
      checked: false
    },
    {
      text: "(+225) Cote d'Ivoire",
      value: "CI",
      checked: false
    },
    {
      text: "(+385) Croatia",
      value: "HR",
      checked: false
    },
    {
      text: "(+599) Curacao",
      value: "CW",
      checked: false
    },
    {
      text: "(+53) Cuba",
      value: "CU",
      checked: false
    },
    {
      text: "(+357) Cyprus",
      value: "CY",
      checked: false
    },
    {
      text: "(+420) Czech Republic",
      value: "CZ",
      checked: false
    },
    {
      text: "(+45) Denmark",
      value: "DK",
      checked: false
    },
    {
      text: "(+253) Djibouti",
      value: "DJ",
      checked: false
    },
    {
      text: "(+1767) Dominica",
      value: "DM",
      checked: false
    },
    {
      text: "(+1809) Dominican Republic",
      value: "DO",
      checked: false
    },
    {
      text: "(+670) East Timor",
      value: "TL",
      checked: false
    },
    {
      text: "(+593) Ecuador",
      value: "EC",
      checked: false
    },
    {
      text: "(+20) Egypt",
      value: "EG",
      checked: false
    },
    {
      text: "(+503) El Salvador",
      value: "SV",
      checked: false
    },
    {
      text: "(+240) Equatorial Guinea",
      value: "GQ",
      checked: false
    },
    {
      text: "(+291) Eritrea",
      value: "ER",
      checked: false
    },
    {
      text: "(+372) Estonia",
      value: "EE",
      checked: false
    },
    {
      text: "(+251) Ethiopia",
      value: "ET",
      checked: false
    },
    {
      text: "(+500) Falkland Islands",
      value: "FK",
      checked: false
    },
    {
      text: "(+679) Fiji",
      value: "FO",
      checked: false
    },
    {
      text: "(+358) Finland",
      value: "FI",
      checked: false
    },
    {
      text: "(+33) France",
      value: "FR",
      checked: false
    },
    {
      text: "(+594) French Guiana",
      value: "GF",
      checked: false
    },
    {
      text: "(+689) French Polynesia",
      value: "PF",
      checked: false
    },
    {
      text: "(+262) French Southern and Antarctic Lands",
      value: "TF",
      checked: false
    },
    {
      text: "(+241) Gabon",
      value: "GA",
      checked: false
    },
    {
      text: "(+220) The Gambia",
      value: "GM",
      checked: false
    },
    {
      text: "(+995) Georgia",
      value: "GE",
      checked: false
    },
    {
      text: "(+49) Germany",
      value: "DE",
      checked: false
    },
    {
      text: "(+233) Ghana",
      value: "GH",
      checked: false
    },
    {
      text: "(+30) Greece",
      value: "GR",
      checked: false
    },
    {
      text: "(+299) Greenland",
      value: "GL",
      checked: false
    },
    {
      text: "(+1473) Grenada",
      value: "GD",
      checked: false
    },
    {
      text: "(+590) Guadeloupe",
      value: "GP",
      checked: false
    },
    {
      text: "(+1671) Guam",
      value: "GU",
      checked: false
    },
    {
      text: "(+502) Guatemala",
      value: "GT",
      checked: false
    },
    {
      text: "(+44) Guernsey",
      value: "GG",
      checked: false
    },
    {
      text: "(+224) Guinea",
      value: "GN",
      checked: false
    },
    {
      text: "(+245) Guinea-Bissau",
      value: "GW",
      checked: false
    },
    {
      text: "(+592) Guyana",
      value: "GY",
      checked: false
    },
    {
      text: "(+509) Haiti",
      value: "HT",
      checked: false
    },
    {
      text: "(+0) Heard Island and McDonald Islands",
      value: "HM",
      checked: false
    },
    {
      text: "(+39) Holy See (Vatican City)",
      value: "VA",
      checked: false
    },
    {
      text: "(+504) Honduras",
      value: "HN",
      checked: false
    },
    {
      text: "(+852) Hong Kong SAR China",
      value: "HK",
      checked: false
    },
    {
      text: "(+36) Hungary",
      value: "HU",
      checked: false
    },
    {
      text: "(+354) Iceland",
      value: "IS",
      checked: false
    },
    {
      text: "(+91) India",
      value: "IN",
      checked: false
    },
    {
      text: "(+62) Indonesia",
      value: "ID",
      checked: false
    },
    {
      text: "(+98) Iran",
      value: "IR",
      checked: false
    },
    {
      text: "(+964) Iraq",
      value: "IQ",
      checked: false
    },
    {
      text: "(+353) Ireland",
      value: "IE",
      checked: false
    },
    {
      text: "(+44) Isle of Man",
      value: "IM",
      checked: false
    },
    {
      text: "(+972) Israel",
      value: "IL",
      checked: false
    },
    {
      text: "(+39) Italy",
      value: "IT",
      checked: false
    },
    {
      text: "(+1876) Jamaica",
      value: "JM",
      checked: false
    },
    {
      text: "(+81) Japan",
      value: "JP",
      checked: false
    },
    {
      text: "(+962) Jordan",
      value: "JO",
      checked: false
    },
    {
      text: "(+7) Kazakhstan",
      value: "KZ",
      checked: false
    },
    {
      text: "(+254) Kenya",
      value: "KE",
      checked: false
    },
    {
      text: "(+686) Kiribati",
      value: "KI",
      checked: false
    },
    {
      text: "(+965) Kuwait",
      value: "KW",
      checked: false
    },
    {
      text: "(+996) Kyrgyzstan",
      value: "KG",
      checked: false
    },
    {
      text: "(+856) Laos",
      value: "LA",
      checked: false
    },
    {
      text: "(+371) Latvia",
      value: "LV",
      checked: false
    },
    {
      text: "(+961) Lebanon",
      value: "LB",
      checked: false
    },
    {
      text: "(+266) Lesotho",
      value: "LS",
      checked: false
    },
    {
      text: "(+231) Liberia",
      value: "LR",
      checked: false
    },
    {
      text: "(+218) Libya",
      value: "LY",
      checked: false
    },
    {
      text: "(+423) Liechtenstein",
      value: "LI",
      checked: false
    },
    {
      text: "(+370) Lithuania",
      value: "LT",
      checked: false
    },
    {
      text: "(+352) Luxembourg",
      value: "LU",
      checked: false
    },
    {
      text: "(+853) Macau SAR China",
      value: "MO",
      checked: false
    },
    {
      text: "(+389) Macedonia",
      value: "MK",
      checked: false
    },
    {
      text: "(+261) Madagascar",
      value: "MG",
      checked: false
    },
    {
      text: "(+265) Malawi",
      value: "MW",
      checked: false
    },
    {
      text: "(+60) Malaysia",
      value: "MY",
      checked: false
    },
    {
      text: "(+960) Maldives",
      value: "MV",
      checked: false
    },
    {
      text: "(+223) Mali",
      value: "ML",
      checked: false
    },
    {
      text: "(+356) Malta",
      value: "MT",
      checked: false
    },
    {
      text: "(+692) Marshall Islands",
      value: "MH",
      checked: false
    },
    {
      text: "(+596) Martinique",
      value: "MQ",
      checked: false
    },
    {
      text: "(+222) Mauritania",
      value: "MR",
      checked: false
    },
    {
      text: "(+230) Mauritius",
      value: "MU",
      checked: false
    },
    {
      text: "(+262) Mayotte",
      value: "YT",
      checked: false
    },
    {
      text: "(+52) Mexico",
      value: "MX",
      checked: false
    },
    {
      text: "(+691) Micronesia, Federated States Of",
      value: "FM",
      checked: false
    },
    {
      text: "(+1808) Midway Island",
      value: "MI",
      checked: false
    },
    {
      text: "(+373) Moldova",
      value: "MD",
      checked: false
    },
    {
      text: "(+377) Monaco",
      value: "MC",
      checked: false
    },
    {
      text: "(+976) Mongolia",
      value: "MN",
      checked: false
    },
    {
      text: "(+382) Montenegro",
      value: "ME",
      checked: false
    },
    {
      text: "(+1664) Montserrat",
      value: "MS",
      checked: false
    },
    {
      text: "(+212) Morocco",
      value: "MA",
      checked: false
    },
    {
      text: "(+258) Mozambique",
      value: "MZ",
      checked: false
    },
    {
      text: "(+264) Namibia",
      value: "NA",
      checked: false
    },
    {
      text: "(+674) Nauru",
      value: "NR",
      checked: false
    },
    {
      text: "(+977) Nepal",
      value: "NP",
      checked: false
    },
    {
      text: "(+31) Netherlands",
      value: "NL",
      checked: false
    },
    {
      text: "(+599) Netherlands Antilles",
      value: "AN",
      checked: false
    },
    {
      text: "(+687) New Caledonia",
      value: "NC",
      checked: false
    },
    {
      text: "(+64) New Zealand",
      value: "NZ",
      checked: false
    },
    {
      text: "(+505) Nicaragua",
      value: "NI",
      checked: false
    },
    {
      text: "(+227) Niger",
      value: "NE",
      checked: false
    },
    {
      text: "(+234) Nigeria",
      value: "NG",
      checked: false
    },
    {
      text: "(+683) Niue",
      value: "NU",
      checked: false
    },
    {
      text: "(+672) Norfolk Island",
      value: "NF",
      checked: false
    },
    {
      text: "(+850) North Korea",
      value: "KP",
      checked: false
    },
    {
      text: "(+1670) Northern Mariana Islands",
      value: "MP",
      checked: false
    },
    {
      text: "(+47) Norway",
      value: "NO",
      checked: false
    },
    {
      text: "(+968) Oman",
      value: "OM",
      checked: false
    },
    {
      text: "(+92) Pakistan",
      value: "PK",
      checked: false
    },
    {
      text: "(+680) Palau",
      value: "PW",
      checked: false
    },
    {
      text: "(+507) Panama",
      value: "PA",
      checked: false
    },
    {
      text: "(+675) Papua New Guinea",
      value: "PG",
      checked: false
    },
    {
      text: "(+595) Paraguay",
      value: "PY",
      checked: false
    },
    {
      text: "(+51) Peru",
      value: "PE",
      checked: false
    },
    {
      text: "(+63) Philippines",
      value: "PH",
      checked: false
    },
    {
      text: "(+870) Pitcairn Islands",
      value: "PN",
      checked: false
    },
    {
      text: "(+48) Poland",
      value: "PL",
      checked: false
    },
    {
      text: "(+351) Portugal",
      value: "PT",
      checked: false
    },
    {
      text: "(+1787) Puerto Rico",
      value: "PR",
      checked: false
    },
    {
      text: "(+974) Qatar",
      value: "QA",
      checked: false
    },
    {
      text: "(+262) Reunion",
      value: "RE",
      checked: false
    },
    {
      text: "(+40) Romania",
      value: "RO",
      checked: false
    },
    {
      text: "(+7) Russia",
      value: "RU",
      checked: false
    },
    {
      text: "(+250) Rwanda",
      value: "RW",
      checked: false
    },
    {
      text: "(+590) Saint Barthelemy",
      value: "BL",
      checked: false
    },
    {
      text: "(+290) Saint Helena",
      value: "SH",
      checked: false
    },
    {
      text: "(+1869) Saint Kitts and Nevis",
      value: "KN",
      checked: false
    },
    {
      text: "(+1758) Saint Lucia",
      value: "LC",
      checked: false
    },
    {
      text: "(+1) Saint Martin",
      value: "MF",
      checked: false
    },
    {
      text: "(+508) Saint Pierre and Miquelon",
      value: "PM",
      checked: false
    },
    {
      text: "(+239) Saint tome and principle",
      value: "ST",
      checked: false
    },
    {
      text: "(+1784) Saint Vincent and the Grenadines",
      value: "VC",
      checked: false
    },
    {
      text: "(+684) Samoa",
      value: "WS",
      checked: false
    },
    {
      text: "(+378) San Marino",
      value: "SM",
      checked: false
    },
    {
      text: "(+966) Saudi Arabia",
      value: "SA",
      checked: false
    },
    {
      text: "(+221) Senegal",
      value: "SN",
      checked: false
    },
    {
      text: "(+381) Serbia",
      value: "RS",
      checked: false
    },
    {
      text: "(+248) Seychelles",
      value: "SC",
      checked: false
    },
    {
      text: "(+232) Sierra Leone",
      value: "SL",
      checked: false
    },
    {
      text: "(+65) Singapore",
      value: "SG",
      checked: false
    },
    {
      text: "(+721) Sint Maarten",
      value: "SX",
      checked: false
    },
    {
      text: "(+421) Slovakia",
      value: "SK",
      checked: false
    },
    {
      text: "(+386) Slovenia",
      value: "SI",
      checked: false
    },
    {
      text: "(+677) Solomon Islands",
      value: "SB",
      checked: false
    },
    {
      text: "(+27) South Africa",
      value: "ZA",
      checked: false
    },
    {
      text: "(+500) South Georgia and the South Sandwich Islands",
      value: "GS",
      checked: false
    },
    {
      text: "(+82) South Korea",
      value: "KR",
      checked: false
    },
    {
      text: "(+211) South Sudan",
      value: "SS",
      checked: false
    },
    {
      text: "(+34) Spain",
      value: "ES",
      checked: false
    },
    {
      text: "(+94) Sri Lanka",
      value: "LK",
      checked: false
    },
    {
      text: "(+249) Sudan",
      value: "SD",
      checked: false
    },
    {
      text: "(+597) Suriname",
      value: "SR",
      checked: false
    },
    {
      text: "(+47) Svalbard",
      value: "SJ",
      checked: false
    },
    {
      text: "(+268) Swaziland",
      value: "SZ",
      checked: false
    },
    {
      text: "(+46) Sweden",
      value: "SE",
      checked: false
    },
    {
      text: "(+41) Switzerland",
      value: "CH",
      checked: false
    },
    {
      text: "(+963) Syria",
      value: "SY",
      checked: false
    },
    {
      text: "(+886) Taiwan",
      value: "TW",
      checked: false
    },
    {
      text: "(+992) Tajikistan",
      value: "TJ",
      checked: false
    },
    {
      text: "(+255) Tanzania",
      value: "TZ",
      checked: false
    },
    {
      text: "(+66) Thailand",
      value: "TH",
      checked: false
    },
    {
      text: "(+228) Togo",
      value: "TG",
      checked: false
    },
    {
      text: "(+690) Tokelau",
      value: "TK",
      checked: false
    },
    {
      text: "(+676) Tonga",
      value: "TO",
      checked: false
    },
    {
      text: "(+1868) Trinidad and Tobago",
      value: "TT",
      checked: false
    },
    {
      text: "(+216) Tunisia",
      value: "TN",
      checked: false
    },
    {
      text: "(+90) Turkey",
      value: "TR",
      checked: false
    },
    {
      text: "(+7370) Turkmenistan",
      value: "TM",
      checked: false
    },
    {
      text: "(+1649) Turks and Caicos Islands",
      value: "TC",
      checked: false
    },
    {
      text: "(+688) Tuvalu",
      value: "TV",
      checked: false
    },
    {
      text: "(+256) Uganda",
      value: "UG",
      checked: false
    },
    {
      text: "(+380) Ukraine",
      value: "UA",
      checked: false
    },
    {
      text: "(+971) United Arab Emirates",
      value: "AE",
      checked: false
    },
    {
      text: "(+44) United Kingdom",
      value: "UK",
      checked: false
    },
    {
      text: "(+1) United States Minor Outlying Islands",
      value: "UM",
      checked: false
    },
    {
      text: "(+1) United States",
      value: "US",
      checked: false
    },
    {
      text: "(+598) Uruguay",
      value: "UY",
      checked: false
    },
    {
      text: "(+998) Uzbekistan",
      value: "UZ",
      checked: false
    },
    {
      text: "(+678) Vanuatu",
      value: "VU",
      checked: false
    },
    {
      text: "(+58) Venezuela",
      value: "VE",
      checked: false
    },
    {
      text: "(+84) Vietnam",
      value: "VN",
      checked: false
    },
    {
      text: "(+1340) Virgin Islands",
      value: "VI",
      checked: false
    },
    {
      text: "(+681) Wallis and Futuna",
      value: "WF",
      checked: false
    },
    {
      text: "(+212) Western Sahara",
      value: "EH",
      checked: false
    },
    {
      text: "(+967) Yemen",
      value: "YE",
      checked: false
    },
    {
      text: "(+260) Zambia",
      value: "ZM",
      checked: false
    },
    {
      text: "(+263) Zimbabwe",
      value: "ZW",
      checked: false
    }
  ]
};
